// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React from 'react';
import styles from './form.module.less';
import cn from 'classnames';
import {t_states} from './types';
import etask from 'zetask';
import {perr} from 'hola_pub_util';
import {login_process} from './utils';
import {State_login_buttons} from './state_login_buttons';
import {State_signup_buttons} from './state_signup_buttons';
import {State_login_with_email} from './state_login_with_email';
import {State_two_step} from './state_two_step';
import {State_signup_with_email} from './state_signup_with_email';
import {State_set_password} from './state_set_password';

interface i_state_with_banner_props {
    Banner?: JSX.Element;
    no_banner?: boolean;
    blocks?: {
        social?: {[propname: string]: boolean},
    };
    states: t_states[];
    enc_url?: string;
    signup_bonus?: boolean;
    next?: string;
    qr_code?: string;
    can_signup: boolean;
    need_plus?: boolean;
    full_page?: boolean;
    global_back?: boolean;
    pro_signup?: boolean;
    go_to: (type:t_states, direction?: number)=>void;
    get_enc_url: ()=>string;
    signup_subscription: boolean;
    set_signup_subscription: (v:boolean)=>void;
    img_set?: string;
    support_email?: string;
}

export const State_with_banner = (p:i_state_with_banner_props)=>{
    const {go_to, states, get_enc_url, signup_subscription,
      set_signup_subscription} = p;
    return <div className={cn(styles.grid,
      !p.no_banner && styles.with_banner)}>
      <div className={cn(styles.form)}
        key={'form_with_slide_banner'}>
        {states.map((state, i)=>{
          return <div className={cn(styles.slide,
            p.img_set=='toolip' && styles.slide_toolip,
            i==0 && styles.prev,
            i==2 && styles.next)} key={state}>
            {state=='login_buttons' && <State_login_buttons blocks={p.blocks}
              full_page={p.full_page}
              on_click={method_name=>{
                if (method_name=='email')
                {
                  go_to('login_with_email');
                  return;
                }
                perr({id: `www_login_${method_name}_click`});
                login_process.social_click(method_name, get_enc_url());
              }}
              go_to={go_to}
              can_signup={p.can_signup}
              Banner={p.Banner}
              no_banner={p.no_banner}
              img_set={p.img_set}
              global_back={p.global_back}/>}
            {state=='signup_buttons' && <State_signup_buttons blocks={p.blocks}
              full_page={p.full_page}
              on_click={method_name=>{
                if (method_name=='email')
                {
                  go_to('signup_with_email');
                  return;
                }
                etask(function*(){
                  yield perr({id: `www_signup_${method_name}_click`});
                  login_process.social_click(method_name, get_enc_url());
                });
              }}
              signup_subscription={signup_subscription}
              set_signup_subscription={set_signup_subscription}
              go_to={go_to}
              Banner={p.Banner}
              no_banner={p.no_banner}
              img_set={p.img_set}
              global_back={p.global_back}/>}
            {state=='set_password' && <State_set_password
              go_to={go_to}
              get_enc_url={get_enc_url}
              Banner={p.Banner}
              img_set={p.img_set}
              next={p.next}
              no_banner={p.no_banner}/>}
            {state=='login_with_email' && <State_login_with_email
              go_to={go_to} get_enc_url={get_enc_url}
              need_plus={p.need_plus} can_signup={p.can_signup}
              can_back={!p.blocks?.social?.hide}
              Banner={p.Banner}
              img_set={p.img_set}
              no_banner={p.no_banner}/>}
            {state=='two_factor' && <State_two_step go_to={go_to}
              get_enc_url={get_enc_url} email={login_process.last_email}
              Banner={p.Banner}
              support_email={p.support_email}
              no_banner={p.no_banner}/>}
            {state=='signup_with_email' && <State_signup_with_email
              go_to={go_to} get_enc_url={get_enc_url}
              qr_code={p.qr_code} signup_bonus={p.signup_bonus}
              signup_subscription={signup_subscription}
              can_back={!p.blocks?.social?.hide}
              Banner={p.Banner}
              pro_signup={p.pro_signup}
              img_set={p.img_set}
              no_banner={p.no_banner}/>}
            </div>;
        })}
      </div>
      {!p.no_banner && <div className={cn(styles.banner)}>
        {p.Banner}
      </div>}
    </div>;
};
